// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__rYECQ","overflowing":"ReadFullNote_overflowing__180Qq"};